/**
 * @file PaginationSkeleton.tsx
 * @description
 * -----------------------------------------------------
 * Componente para el skeleton de la paginación
 * -----------------------------------------------------
 * @version 0.0.1a
 * @created 2025-04-10
 * @modified 2025-06-26
 * @author DLTCode
 * @author Ainhoa
 * @author Ismael Benabdellah
 * @copyright © DLTCode
 * @license Private
 * */

"use client";

import { c as _c } from "react/compiler-runtime";
const PaginationSkeleton = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <article className="pagination-skeleton"><section className="pagination-skeleton--text" /><section className="pagination-skeleton--select" /><section className="pagination-skeleton--btn" /></article>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default PaginationSkeleton;